import { v4 as uuidv4 } from 'uuid'

let traceId = uuidv4()

/**
 * Sets a traceId for analytics and remote logging.
 *
 * @returns traceId sent from query params or AuthUI generated UUID if unavailable.
 */
export function getTraceId(id: string | null = ''): string {
  traceId = id || traceId
  return traceId
}
